/**
 * Created by mukund on 6/10/15.
 */
'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('channel', {
                parent: 'site',
                url: '/channel/:collectionId',
                params: {
                    destinationFolderId: null,
                    destinationFolderCollectionTree: null,
                    showUnpublished: false
                },
                data: {
                    roles: [],
                    pageTitle: 'channel.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/collection/templates/collection.html',
                        controller: 'CollectionController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('channel');
                        return $translate.refresh();
                    }]
                }
            });
    });
